import _ from 'lodash';
import { createRefPath_client } from '../../firestoreData/appData/appRefPaths';

/**
 * 
 * @param {string} pathViews 
 * @param {function} callback - whether or not the client has any events
 * @description 
 */
export const clientHasEvents = (pathViews, callback) => {
  const _getRef = createRefPath_client(pathViews, ['events'])
  database_fns.get_data({ refPath: _getRef }).then(res => {
    callback({ hasEvents: !_.isEmpty(res) })
  })
} 